import { __assign, __rest } from "tslib";
import React, { useEffect, useState } from 'react';
import useInView from '../hooks/useInView';
var defaultDelay = 500;
var defaultThreshold = 0;
var defaultRootMargin = '0px 0px 200px';
var LazyLoading = function (_a) {
    var children = _a.children, _b = _a.as, as = _b === void 0 ? 'div' : _b, _c = _a.options, options = _c === void 0 ? {} : _c, _d = _a.temporary, temporary = _d === void 0 ? {} : _d, props = __rest(_a, ["children", "as", "options", "temporary"]);
    var Container = as;
    var _e = options.delay, delay = _e === void 0 ? defaultDelay : _e, _f = options.threshold, threshold = _f === void 0 ? defaultThreshold : _f, _g = options.rootMargin, rootMargin = _g === void 0 ? defaultRootMargin : _g;
    var _h = useState(false), isVisible = _h[0], setIsVisible = _h[1];
    var _j = useState(temporary), temporaryProps = _j[0], addTemporaryProps = _j[1];
    var _k = useInView({
        rootMargin: rootMargin,
        threshold: threshold,
        triggerOnce: true,
    }), ref = _k.ref, inView = _k.inView;
    useEffect(function () {
        var timer;
        if (inView) {
            setIsVisible(true);
            timer = setTimeout(function () { return addTemporaryProps({}); }, delay);
        }
        return function () { return timer && clearTimeout(timer); };
    }, [inView]);
    var componentsProps = __assign(__assign({}, props), temporaryProps);
    return (React.createElement(Container, __assign({}, componentsProps, { "data-testid": "lazyload-container", ref: ref }), isVisible && children));
};
export default LazyLoading;
//# sourceMappingURL=LazyLoading.js.map